//back to this
import React, { useEffect } from "react";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Form,
  Input,
  Modal,
  Select,
  Switch,
  Upload,
  Popconfirm,
} from "antd";
import {
  beddingOptions,
  facilityOptions,
  roomTypeOptions,
  roomViewOptions,
} from "./const";
import { useRoomingList } from "./modules/useRoomingList";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
const { Option } = Select;

function RoomingListTemplate() {
  const {
    form,
    rooms,
    imageFiles,
    manualBeds,
    navigate,
    isModalVisible,
    handleEdit,
    handleDelete,
    handleImageChange,
    handleImageRemove,
    handleModalOk,
    handleModalCancel,
    setManualBeds,
    reorderRooms,
    reorderImages,
  } = useRoomingList();

  const uploadButton = (
    <div>
      <UploadOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    // Handle room reorder
    if (source.droppableId === "rooms" && destination.droppableId === "rooms") {
      if (source.index === destination.index) return;
      reorderRooms(source.index, destination.index);
      return;
    }
    // Handle images reorder
    if (
      source.droppableId === "images" &&
      destination.droppableId === "images"
    ) {
      if (source.index === destination.index) return;
      reorderImages(source.index, destination.index);
      return;
    }
  };

  const onBeforeCapture = () => {
    try {
      const el = document.querySelector('[data-rbd-droppable-id="rooms"]');
      console.log("onBeforeCapture - droppable element present:", !!el);
    } catch (e) {
      console.log("onBeforeCapture error", e);
    }
  };

  const onDragStart = (start) => {
    try {
      console.log("onDragStart", start);
      const el = document.querySelector('[data-rbd-droppable-id="rooms"]');
      console.log("onDragStart - droppable element present:", !!el);
      // Debug current rooms ids
      try {
        const ids = (rooms || []).map((r) => String(r._id));
        console.log("onDragStart - rooms ids:", ids);
        const domIds = Array.from(
          document.querySelectorAll("[data-rbd-draggable-id]")
        ).map((n) => n.getAttribute("data-rbd-draggable-id"));
        console.log("onDragStart - DOM draggable ids:", domIds);
        console.log(
          "onDragStart - dragged id present in rooms?",
          ids.includes(start.draggableId)
        );
        console.log(
          "onDragStart - dragged id present in DOM?",
          domIds.includes(start.draggableId)
        );
      } catch (e2) {
        console.log("onDragStart - debug ids error", e2);
      }
    } catch (e) {
      console.log("onDragStart error", e);
    }
  };

  // Dedicated handler for images drag-end when images Droppable is inside Modal
  const onImagesDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (
      source.droppableId === "images" &&
      destination.droppableId === "images"
    ) {
      if (source.index === destination.index) return;
      reorderImages(source.index, destination.index);
    }
  };

  useEffect(() => {
    const footerEl = document.querySelector("footer.footer");
    if (!footerEl) return;
    if (isModalVisible) {
      footerEl.classList.add("update-index-footer");
    } else {
      footerEl.classList.remove("update-index-footer");
    }
    return () => {
      if (footerEl) footerEl.classList.remove("update-index-footer");
    };
  }, [isModalVisible]);

  return (
    <div className="container">
      <h1>Room Management</h1>
      <Button
        className="mb-3"
        icon={<PlusOutlined />}
        type="primary"
        onClick={() => navigate("/admin/addroom")}
      >
        Add New Room
      </Button>

      <DragDropContext
        key={`ddc-${rooms.length}`}
        onDragEnd={onDragEnd}
        onDragStart={onDragStart}
        onBeforeCapture={onBeforeCapture}
      >
        <Droppable
          key={`droppable-${rooms.length}`}
          droppableId="rooms"
          direction="horizontal"
        >
          {(provided) => (
            <div
              className="row"
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {rooms.map((room, index) => (
                <Draggable
                  key={room._id}
                  draggableId={String(room._id)}
                  index={index}
                >
                  {(draggableProvided) => (
                    <div
                      className="col-md-4 mb-4"
                      ref={draggableProvided.innerRef}
                      {...draggableProvided.draggableProps}
                      style={{
                        ...(draggableProvided.draggableProps?.style || {}),
                      }}
                    >
                      <Card
                        hoverable
                        style={{ cursor: "move" }}
                        cover={
                          <img
                            alt="Room"
                            src={
                              room.imageurls?.[0] ||
                              "https://via.placeholder.com/150"
                            }
                            style={{ height: "200px", objectFit: "cover" }}
                          />
                        }
                        actions={[
                          <Button
                            type="primary"
                            onClick={() => handleEdit(room)}
                          >
                            Edit
                          </Button>,
                          <Popconfirm
                            title="Are you sure to delete this room?"
                            onConfirm={() => handleDelete(room._id)}
                            onCancel={() => {}}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button type="link" danger>
                              Delete
                            </Button>
                          </Popconfirm>,
                        ]}
                        {...draggableProvided.dragHandleProps}
                      >
                        <h1 style={{ color: "#443d80" }}>
                          <strong>{room.name}</strong>
                        </h1>
                        <p>
                          <strong>Room Type:</strong> {room.type}
                        </p>
                        <p>
                          <strong>Room View:</strong> {room.roomview}
                        </p>
                        <p>
                          <strong>Room Size:</strong> {room.roomsize} sq meters
                        </p>
                        <p>
                          <strong>Bed Type:</strong> {room.bedding}
                        </p>
                        <p>
                          <strong>Max Adults:</strong> {room.maxadult}
                        </p>
                        <p>
                          <strong>Max Children:</strong> {room.maxchild}
                        </p>
                        <p>
                          <strong>Extra Bed:</strong>
                          {room.extrabed ? "Yes" : "No"}
                        </p>
                        <p>
                          <strong>Smoking Policy:</strong>{" "}
                          {room.smokingpolicy ? "Allowed" : "No Smoking"}
                        </p>
                      </Card>
                    </div>
                  )}
                </Draggable>
              ))}

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      {/* Modal for Editing Room */}
      <Modal
        title="Edit Room"
        visible={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText="Save"
        cancelText="Cancel"
        getContainer={false}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Room Name"
            rules={[{ required: true, message: "Please enter room name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Room Description"
            rules={[
              {
                required: true,
                message: "Please enter your room description",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="maxcount"
            label="Number of Rooms"
            rules={[
              { required: true, message: "Please enter the number of rooms" },
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name="rentperday"
            label="Rent Per Day"
            rules={[
              { required: true, message: "Please enter the rent per day" },
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name="type"
            label="Room Type"
            rules={[{ required: true, message: "Please select room type" }]}
          >
            <Select placeholder="Select Room Type">
              {roomTypeOptions.map((option) => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="roomview"
            label="Room View"
            rules={[{ required: true, message: "Please select room view" }]}
          >
            <Select placeholder="Select Room View">
              {roomViewOptions.map((option) => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="roomsize"
            label="Room Size (sq meters)"
            rules={[{ required: true, message: "Please enter room size" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="maxadult"
            label="Max Adults"
            rules={[{ required: true, message: "Please enter max adults" }]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name="maxchild"
            label="Max Children"
            rules={[{ required: true, message: "Please enter max children" }]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name="smokingpolicy"
            label="Smoking Policy"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select Smoking Policy">
              <Option value={true}>Allowed</Option>
              <Option value={false}>No Smoking</Option>
            </Select>
          </Form.Item>
          <Form.Item name="extrabed" label="Extra Bed" valuePropName="checked">
            <Switch
              onChange={(checked) => form.setFieldsValue({ extrabed: checked })}
            />
          </Form.Item>

          <Form.Item
            name="bedding"
            label="Bedding"
            rules={[{ required: true, message: "Please select bed type" }]}
          >
            <Select
              placeholder="Select Bed Type"
              onChange={(value) => form.setFieldsValue({ bedding: value })}
            >
              {beddingOptions.map((option) => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {form.getFieldValue("bedding") === "Input No of Bed Manually" && (
            <Form.Item
              name="manualBeds"
              label="Number of Beds"
              rules={[
                { required: true, message: "Please enter number of beds" },
              ]}
            >
              <Input
                type="number"
                value={manualBeds}
                onChange={(e) => setManualBeds(e.target.value)}
              />
            </Form.Item>
          )}

          <Form.Item name="facilities" label="Facilities">
            <Select
              mode="multiple"
              allowClear
              placeholder="Select Facilities"
              value={form.getFieldValue("facilities")}
            >
              {facilityOptions.map((option) => (
                <Option key={option} value={option}>
                  {option}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <DragDropContext
            key={`images-ddc-${isModalVisible}`}
            onDragEnd={onImagesDragEnd}
          >
            <Form.Item name="images" label="Upload Images (up to 5)">
              <div
                style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}
              >
                Note: Maximum upload size: 2MB, format: JPG
              </div>
              <Upload
                listType="picture-card"
                multiple
                accept="image/*"
                beforeUpload={() => false}
                onChange={handleImageChange}
                onRemove={handleImageRemove}
                fileList={imageFiles}
                showUploadList={false}
              >
                {imageFiles.length >= 5 ? null : uploadButton}
              </Upload>

              {/* Draggable thumbnails for selected images */}
              <Droppable droppableId="images" direction="horizontal">
                {(provided) => (
                  <div
                    className="d-flex mt-2"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    style={{ gap: 8, overflowX: "auto", padding: "6px 4px" }}
                  >
                    {(imageFiles || []).map((file, idx) => {
                      const src =
                        file.url ||
                        (file.originFileObj &&
                          URL.createObjectURL(file.originFileObj));
                      return (
                        <Draggable
                          key={file.uid}
                          draggableId={String(file.uid)}
                          index={idx}
                        >
                          {(draggableProvided) => (
                            <div
                              ref={draggableProvided.innerRef}
                              {...draggableProvided.draggableProps}
                              {...draggableProvided.dragHandleProps}
                              style={{
                                width: 100,
                                height: 80,
                                border: "1px solid #e8e8e8",
                                borderRadius: 4,
                                position: "relative",
                                flex: "0 0 auto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                overflow: "hidden",
                                ...draggableProvided.draggableProps.style,
                              }}
                            >
                              {src ? (
                                <img
                                  src={src}
                                  alt={file.name}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div style={{ fontSize: 12, color: "#888" }}>
                                  {file.name}
                                </div>
                              )}
                              <button
                                type="button"
                                onClick={() => handleImageRemove(file)}
                                style={{
                                  position: "absolute",
                                  top: 4,
                                  right: 4,
                                  background: "rgba(0,0,0,0.6)",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: 20,
                                  height: 20,
                                  cursor: "pointer",
                                  padding: 0,
                                  lineHeight: "18px",
                                }}
                              >
                                ×
                              </button>
                            </div>
                          )}
                        </Draggable>
                      );
                    })}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </Form.Item>
          </DragDropContext>
        </Form>
      </Modal>
    </div>
  );
}

export default RoomingListTemplate;
